import { get, writable } from "svelte/store"
import { translations } from "./config"
import { getGeneralInformation } from "./api"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    hash: (typeof window !== "undefined" && window.location?.hash) || "",
    push: false,
    pop: false,
}
export const location = writable(initLoc)
export const navstore = writable<{ [key: number]: Navigation }>({})
export const pfadstore = writable<{ [path: string]: NavElement }>({})

function spracheVonUrl(): string {
    return get(location)?.path?.match(/^\/en(\/.*)?$/) ? "en" : "de"
}

export const sprache = writable<string>(spracheVonUrl())

location.subscribe(() => {
    const s = get(sprache)
    const newS = spracheVonUrl()
    if (s != newS) {
        sprache.set(newS)
    }
})

export const i18n = writable((key: string): string => {
    return key
})
sprache.subscribe((l) => {})

// General Information

export const generalInfo = writable<GeneralInfo>()
const getGeneralProjectInformation = async () => {
    const infos = await getGeneralInformation()
    console.log("infos", infos)
    if (infos && infos.length) {
        generalInfo.set(infos[0])
    }
    console.log("generalInfo", generalInfo)
}
getGeneralProjectInformation()
